import gsap from "gsap";
import { useLayoutEffect } from "react";

const Rates = () => {
    useLayoutEffect(() => {
        let ctx = gsap.context(() => {
			let startMarker = "85%";
			gsap.from("#titleRates", {
				scrollTrigger: {
					trigger: ".rates",
					start: `20% ${startMarker}`,
				},
				y: 50,
				opacity: 0,
				duration: .7,
			})
            gsap.from("#subTitleRates", {
				scrollTrigger: {
					trigger: ".rates",
					start: `20% ${startMarker}`,
				},
                delay: .2,
				y: 50,
				opacity: 0,
				duration: .7,
			})
            gsap.from("#rate1", {
				scrollTrigger: {
					trigger: ".rates",
					start: `50% ${startMarker}`,
				},
				y: -50,
				opacity: 0,
				duration: .7,
			})
            gsap.from("#rate2", {
				scrollTrigger: {
					trigger: ".rates",
					start: `50% ${startMarker}`,
				},
                delay: .2,
				y: -50,
				opacity: 0,
				duration: .7,
			})
		});
		return () => ctx.revert();
    }, []);

    return (
        <div className="rates">
            <div className="naming" id="titleRates">Тарифы</div>
            <h2 id="subTitleRates">Доступные варианты использования</h2>
            <ul className="ratesList">
                <li id="rate1">
                    <div className="content">
                        <div className="title">[Демо]</div>
                        <div className="desc">Двухнедельный доступ к просмотру демонстрационных данных, без возможности редактирования.</div>
                        <div className="price">0 ₽/мес</div>
                    </div>
                </li>
                <li id="rate2">
                    <div className="content">
                        <div className="title">[Стандарт]</div>
                        <div className="desc">Неограниченные расчеты, экспорт в Excel, настройка формул.</div>
                        <div className="price">1990 ₽/мес</div>
                    </div>
                </li>
                {/* <li>
                    <div className="content">
                        <div className="title">[Тестировщик]</div>
                        <div className="desc">Тариф доступен только тестировщикам приложения.</div>
                        <div className="price">0 ₽/мес</div>
                    </div>
                </li> */}
            </ul>
            <button className="activeButton" onClick={() => window.location.href = "https://calc.financeprice.ru/"}>Начать расчет</button>
        </div>
    );
}

export default Rates;